export default "/images/vendor/flag-icon-css/flags/1x1/no.svg?266dbd6fc3e66414aa3c05bb90510bf7";